/*
 * HHG Guide — table of contents builder.
 * Assigns slugified, de-duplicated ids to the H2 headings typed into the
 * article body (.hhg-guide__prose only, so product-module headings are
 * skipped), fills the server-rendered TOC container with anchor links, and
 * reveals it when there are at least three headings. Anchor clicks scroll
 * smoothly and move focus to the heading. Without JS the TOC stays hidden
 * and the article reads top to bottom unchanged.
 */
(function () {
  'use strict';

  function slugify(text) {
    return (
      String(text)
        .toLowerCase()
        .trim()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section'
    );
  }

  function init() {
    var body = document.querySelector('[data-hhg-guide-body]');
    if (!body) return;

    var headings = Array.prototype.slice.call(
      body.querySelectorAll('.hhg-guide__prose h2')
    );

    // Slugified ids, de-duplicated with -2, -3, ...
    var used = {};
    headings.forEach(function (heading) {
      if (heading.id) {
        used[heading.id] = 1;
        return;
      }
      var slug = slugify(heading.textContent);
      var id = slug;
      var n = 2;
      while (used[id] || document.getElementById(id)) {
        id = slug + '-' + n;
        n += 1;
      }
      used[id] = 1;
      heading.id = id;
    });

    var toc = document.querySelector('[data-hhg-toc]');
    if (!toc) return;
    var list = toc.querySelector('[data-hhg-toc-list]');
    if (!list || headings.length < 3) return;

    headings.forEach(function (heading) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
    toc.hidden = false;

    toc.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.pushState) {
        history.pushState(null, '', link.getAttribute('href'));
      }
      target.tabIndex = -1;
      target.focus({ preventScroll: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
